import axios from 'axios';
import Swal from 'sweetalert2';
import { fetchAllPositions } from './fetchAllPositions';

export function addPosition(projectId, params) {
  return (dispatch) => {
    return axios
      .post(`/project/${projectId}/position`, params)
      .then((response) => {
        const { status } = response.data;
        if (status === 'SUCCESS') {
          Swal.fire({
            title: 'Success',
            text: 'Successfully added a position',
            icon: 'success',
            confirmButtonColor: '#3f51b5',
          });
          dispatch(fetchAllPositions(projectId));
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
}
